import { FC, ReactElement, ReactNode } from 'react';
import { Flex, Box } from '@chakra-ui/react';
interface CbMainLayoutProps {
  sideNavigationContainer?: ReactElement;
  sideNavOffset?: string;
  children?: ReactNode;
}
export const CbMainLayout: FC<CbMainLayoutProps> = ({
  sideNavigationContainer,
  sideNavOffset,
  children
}) => {
  const offset = sideNavigationContainer && sideNavOffset ? sideNavOffset : 'auto';
  const verticalOffset = sideNavigationContainer ? 4 : 'auto';
  return <>
      <Box backgroundColor="cloud.200" height="100vh" width="100vw" position="fixed" data-sentry-element="Box" data-sentry-source-file="CbMainLayout.tsx"></Box>
      <Flex width={{
      md: '100%'
    }} marginX="auto" position="relative" alignItems="flex-start" data-sentry-element="Flex" data-sentry-source-file="CbMainLayout.tsx">
        {sideNavigationContainer && <Box position={{
        base: 'absolute',
        md: 'sticky'
      }} left="0" top="0" height="auto">
            {sideNavigationContainer}
          </Box>}
        <Box marginLeft={{
        md: offset
      }} paddingY={verticalOffset} paddingX={{
        md: 2
      }} width={{
        md: '100%'
      }} position="relative" data-sentry-element="Box" data-sentry-source-file="CbMainLayout.tsx">
          {children}
        </Box>
      </Flex>
    </>;
};